/**
 * Scroll reveal: section headings and cards fade up as they enter the screen.
 * The first section (hero) is never animated so the LCP image paints at once.
 * Without JS or with reduced motion nothing is hidden (the zr-anim class is never added).
 */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var ITEMS = [
    '.usp-bar__item',
    '.collection-card',
    '.resource-list__item',
    '.resource-list__carousel',
    '.featured-blog-posts-card',
    '.essentials-tabs__item',
    '.zw-spot__media',
    '.zw-spot__content',
    '.must-haves-tile',
    '.stl-promo__content',
    '.stl-preview__card',
    '.editorial-tile',
    '.brand-story-duo__media',
    '.brand-story-duo__content',
    '.customer-stories__card',
    '.email-signup-block',
    '.product-grid__item',
    'main .shopify-section h2'
  ].join(',');

  var sections = document.querySelectorAll('main .shopify-section');
  var targets = [];

  sections.forEach(function (section, i) {
    if (i === 0) return;
    section.querySelectorAll(ITEMS).forEach(function (el) {
      // Skip anything nested inside another revealed element (e.g. a heading inside a card).
      if (el.parentElement && el.parentElement.closest('.zr')) return;
      // Carousels reveal as one block; their slides are cloned/scrolled by other scripts.
      if (!el.matches('.resource-list__carousel') && el.closest('.resource-list__carousel')) return;
      el.classList.add('zr');
      targets.push(el);
    });
  });

  if (!targets.length) return;

  // Stagger siblings: each card in a row starts a little after the previous one.
  targets.forEach(function (el) {
    var siblings = Array.prototype.filter.call(el.parentElement.children, function (c) {
      return c.classList.contains('zr');
    });
    var index = siblings.indexOf(el);
    if (index > 0) el.style.setProperty('--zr-delay', Math.min(index, 6) * 90 + 'ms');
  });

  document.documentElement.classList.add('zr-anim');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('zr-in');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
})();
